import { api } from "./configs/axiosConfigs"

export const priceListSegmentAPI = {
    
    getPriceListSegments: async (data:any) => {
        const response = await api.get(
            '/priceListSegment', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createPriceListSegment: async (data: any) => {
        const response = await api.post(
            '/priceListSegment/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    editPriceListSegment: async (idlist: number, data: any) => {
        const response = await api.patch(
            `/priceListSegment/${idlist}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    deletePriceListSegment: async (idlist: number) => {
        const response = await api.delete(
            `/priceListSegment/${idlist}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}